



























import Vue from 'vue';
import MainArea from '@/components/MainArea.vue';
import ImageArea from '@/components/ImageArea.vue';

import Store from '@/services/Store';
import { Piano, fId } from '@/services/Utility';

export default Vue.extend({
	name: 'QuizQuestion',
	props: {
		selectedAnswer: String,
	},
	mounted() {
		let t = Store.quizState.getQuizTitle().match(/(\w+)/g);
		let title = t !== null ? `__${t[0]}${typeof t[1] !== 'undefined' ? `_${t[1]}` : ''}` : '';
		Piano ({t: 'page.display', p: {
			inhaltstyp: title,
			seitenname_id: `questionPage_${Store.quizState.getQuizTitle()}`,
			seitentitel: `Frage: ${this.getCurrentQuestionText().substr(0, 30)}...`,
		}});
		window.setTimeout(() => {
			let prms = { status: 200, h: this.$root.$el.clientHeight, tgt: fId };
			// console.log(`QuizQuestion: will post ${JSON.stringify(prms)}`);
			if (window.self !== window.top) {
				parent.postMessage(prms, 'https://www.br.de');
			}
		}, 500);
	},
	methods: {
		// Display helper methods

		getCurrentQuestionImage() {
			return Store.quizState.getCurrentQuestionImage();
		},
		getCurrentQuestionText() {
			return Store.quizState.getCurrentQuestionText();
		},
		getCurrentQuestionAudio() {
			return Store.quizState.getCurrentQuestionAudio();
		},
		getCurrentOptions() {
			return Store.quizState.getCurrentOptions();
		},

		buttonStatus(answer: string) {
			// Return status only for the currently selected answer:
			if (this.selectedAnswer != answer) return '';
			return this._isAnswerCorrect(answer) ? 'correct' : 'wrong';
		},

		// Handlers

		handleAnswerClick(answer: string) {
			Piano({t:'click.navigation', p:{click:'btnAnswer', click_chapter1:'navigationButton'}});
			this.$router.push({ name: 'QuizFeedback', params: { selectedAnswer: answer } });
		},

		// Methods not used in the template

		_isAnswerCorrect(answer: string) {
			return Store.quizState.getCorrectAnswers().includes(answer);
		},
	},
	components: {
		MainArea,
		ImageArea,
	},
	beforeRouteEnter(to, from, next) {
		if (to.params.quiz != 'play') next({ name: 'QuizIntro' });
		else next();
	},
});
